<template>
    <span :hidden="!isAdminStatus">
        <a
            :aria-expanded="troubleCollaps"
            class="sidebar-menu-item nav-link"
            data-toggle="collapse"
            @click="(troubleCollaps=!troubleCollaps)"
        >
            <template>
                <i class="fa pr-2 fa-tools text-indigo"></i>
                <span class="nav-link-text">Troubleshooting<b class="caret"></b></span>
            </template>
        </a>
        <collapse-transition :duration="{enter: 500, leave: 500}">
            <div v-show="troubleCollaps" id="collapse-just" :class="troubleCollaps?'show':''" class="collapse">
                <ul class="nav nav-sm flex-column">
                  <slot v-for="(item, index) in troubleLinks" name="title">
                        <router-link
                            :key="index"
                            :target="item.url"
                            class="nav-link"
                            :href="item.url"
                            :to="item.url"
                            @click.native="linkClick"
                        >
                            <template>
                                <i :class="`${item.icon} text-${item.color} pr-2`"></i>
                                <span class="nav-link-text">{{ item.label }}</span>
                            </template>
                        </router-link>
                    </slot>
                  </ul>
                </div>
          </collapse-transition>
        </span>
</template>
<script>
import {CollapseTransition} from "vue2-transitions";
import configDirective from "@/common/directive/config-directive";
import initService from "../../../common/api-services/init-service";

export default {
  name: 'side-trouble-custom-group',
  components: {
    CollapseTransition
  },
  data() {
    return {
      isAdminStatus: false,
      groups: [],
      troubleLinks: [],
      troubleCollaps: false,
    }
  },
  mounted() {
    this.troubleLinks = configDirective.getTroubleLinks();
    //console.log('trouble:', this.troubleLinks);
    this.isAdminStatus = initService.getAdministratorRole() || initService.getPortalAdminRole();
  },
  methods: {
    linkClick() {
      if (
          this.autoClose &&
          this.$sidebar &&
          this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },
  }
}
</script>
